// src/pages/Orders.tsx
import Sidebar from "../components/Sidebar";
import DashboardTopbar from "../components/DashboardTopbar";

const Orders = () => {
  const sampleOrders = [
    {
      id: "ORD-1001",
      customer: "Alex Trie",
      items: ["Burger", "Fries"],
      status: "On progress",
      total: "$18.99",
    },
    {
      id: "ORD-1002",
      customer: "Jerome Bell",
      items: ["Pizza"],
      status: "Ready to serve",
      total: "$12.00",
    },
  ];

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex-1 bg-[#f9f9f9]">
        <DashboardTopbar
          logoUrl="/logo.png"
          name="FullPlateNow Restaurant"
          address="123 Main St, Springfield"
        />
        <div className="p-6">
          <h2 className="text-2xl font-bold mb-6">Active Orders</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {sampleOrders.map((order) => (
              <div
                key={order.id}
                className="bg-white p-4 shadow rounded-xl space-y-2"
              >
                <div className="flex justify-between items-center">
                  <h3 className="font-semibold">{order.customer}</h3>
                  <span className="text-sm bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full">
                    {order.status}
                  </span>
                </div>
                <p className="text-sm text-gray-500">
                  {order.items.join(", ")}
                </p>
                <div className="text-right font-bold">{order.total}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Orders;
